import { DatePicker } from "antd";
import dayjs from "dayjs";
import { rightsService } from "../../../services/rightsService";

// Habilitation : antidater la date de règlement d'un sinistre à la validation.
export const HAB_ANTIDATER_REGLEMENT = "HSI095";
export const canAntidaterReglement = () => rightsService(HAB_ANTIDATER_REGLEMENT);

// Message renvoyé par le backend en cas de refus (403 sans habilitation,
// 409 cession du mois déjà effectuée, 422 date future) ; null sinon.
export const messageRefusAntidatage = (e) => {
    const data = e?.response?.data;
    return data?.code === "MOTIF_EDITION" ? data.message : null;
};

// Champ optionnel à insérer dans les Modal.confirm de validation d'un décaissement.
// Le contenu d'un Modal.confirm n'est pas re-rendu : la date choisie est écrite
// dans dateRef.current ("YYYY-MM-DD", null = date du jour). Visible uniquement
// sous habilitation HSI095 ; le backend re-vérifie et refuse si la cession du
// mois visé est déjà effectuée pour la compagnie/catégorie du contrat.
const AntidatageDateReglement = ({ dateRef }) => {
    if (!canAntidaterReglement()) return null;
    return (
        <div style={{ marginTop: 12 }}>
            <div style={{ fontWeight: 600, marginBottom: 4 }}>Date de règlement (antidatage)</div>
            <DatePicker
                style={{ width: 240 }}
                format="DD/MM/YYYY"
                placeholder="Par défaut : aujourd'hui"
                allowClear
                disabledDate={(d) => d && d.isAfter(dayjs().endOf("day"))}
                onChange={(d) => { dateRef.current = d ? d.format("YYYY-MM-DD") : null; }}
            />
            <div style={{ fontSize: 12, color: "#8c8c8c", marginTop: 4 }}>
                Laisser vide pour utiliser la date du jour. Refusé si la cession du mois choisi est déjà effectuée.
            </div>
        </div>
    );
};

export default AntidatageDateReglement;
